import React from "react";
import {Avatar} from "@material-ui/core";
import {formatDate, Initials, yearsOfExpierence} from "../../vendors/utils/common";
import {RatingIcon} from '../../elements/svgIcons'



const LawyerBox = (props: any) => {
    const lawyer = props.data;
    return (
        <div className='d-flex lawyer-box'>
            <Avatar alt={lawyer.name}
                    className={'mr-3'}
                    color={'primary'}
                    src={lawyer.imageUrl}>{Initials(lawyer.name)}</Avatar>
            <div>
                <h3 className="lawyer-box-name">
                    {lawyer.name}
                </h3>
               <p className="text-black-50">
                    Rated by lawyers&nbsp;&nbsp;
                    <span className={`text-black lawyer-rating ${lawyer.rating ? `font-weight-medium` : ``}`}><RatingIcon />&nbsp;{lawyer.rating || 'N/A'}</span>&nbsp;
                </p>

                <p className="text-black-50 lawyer-box-license">
                    Licensed in&nbsp;
                    <span className='text-black'>{lawyer.States[0].abbreviation}</span>,&nbsp;
                    <span className='text-black'>{lawyer.States[0].barNumber}</span>
                </p>
                <p className="text-black-50">
                    Years of experience&nbsp;
                    <span className='text-black'>{yearsOfExpierence(lawyer.States[0].admission_date) === 0 ? 'Freshman' : yearsOfExpierence(lawyer.States[0].admission_date)}</span>
                </p>
                <p className="text-black-50">
                    Active as of&nbsp;
                    <span className='text-black'>{formatDate(lawyer.createdAt, 'MM/DD/YY')}</span>
                </p>
            </div>
        </div>
    )
};

export default LawyerBox;
